import React from "react";
import ProformaInvoices from "pages/ProformaInvoices";

const Index = () => (
  <ProformaInvoices
    pageTitle="سفارش‌های در انتظار تأیید واریزی"
    totalLabel="سفارش‌های در انتظار تأیید"
    emptyText="سفارشی با واریزی در انتظار تأیید وجود ندارد"
    showCreateButton={false}
    orderStatus={null}
    section="allOrders"
    paymentConfirmation="pending"
    showFilters
    showDateColumn
    mobileColumns={2}
  />
);

export default Index;
